/**
 * Extract error message from API error response
 * Handles Pydantic validation errors which return objects instead of strings
 */
export const getErrorMessage = (error, defaultMessage = 'Si è verificato un errore') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return defaultMessage;
  }
  
  // If detail is a string, return it
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an array (Pydantic validation errors)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      if (typeof err === 'string') return err;
      if (err.msg) return err.msg;
      if (err.message) return err.message;
      return JSON.stringify(err);
    }).join(', ');
  }
  
  // If detail is an object with msg property
  if (detail.msg) {
    return detail.msg;
  }
  
  // If detail is an object with message property
  if (detail.message) {
    return detail.message;
  }
  
  // Fallback
  return defaultMessage;
};
